import { render, staticRenderFns } from "./UserListInfo.vue?vue&type=template&id=44a4a828&"
import script from "./UserListInfo.vue?vue&type=script&lang=js&"
export * from "./UserListInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports